import { Component, input } from '@angular/core';
import { CardModule } from '@openng/optimus-ui/card';
import { CurrencyFormatPipe } from '@zayan-erp/shared';
import { DsmDepositSummary } from '../../models/dsm-deposit.models';

@Component({
  selector: 'dsm-aps-deposits-financial-summary',
  standalone: true,
  imports: [CardModule, CurrencyFormatPipe],
  templateUrl: './dsm-aps-deposits-financial-summary.component.html'
})
export class DsmApsDepositsFinancialSummaryComponent {
  summary = input<DsmDepositSummary[] | undefined>(undefined);
}
